import { useNavigate } from "react-router";
import Button from "../../atoms/button";
import "./stageTheme.scss";

const StageTheme = () => {
  const navigation = useNavigate();
  return (
    <section className="stageTheme">
      <img
        src="images/living-room.png"
        alt="Kompleksowe Wykończenia Wnętrz"
        className="stageTheme__banner"
      />
      <div className="stageTheme__content">
        <h1 className="stageTheme__title">
          Kompleksowe{" "}
          <span className="stageTheme__title--highlight">Wykończenia</span>
          wnętrz
        </h1>
        <p className="stageTheme__description">
          Od stanu deweloperskiego do zamieszkania. Od pierwszych prac po
          ostatni detal.
        </p>

        <div className="stageTheme__action">
          <Button
            variant="primary"
            text="Zobacz naszą ofertę"
            icon=""
            onClick={() => navigation("/oferta")}
          />
        </div>
      </div>
    </section>
  );
};

export default StageTheme;
